import { useQuery } from '@tanstack/react-query';

import type { TStaffInterviewQuery } from '@/services/interviews';

import { INTERVIEW_KEYS } from '@/constants/queryKeys';
import { errorUtils } from '@/services/errors';
import { interviewsService } from '@/services/interviews';
import { useStaffSession } from '@/hooks/auth';

const useStaffInterviews = (query: TStaffInterviewQuery, isEnabled: boolean = true) => {
  const { data: session } = useStaffSession();

  return useQuery({
    queryKey: INTERVIEW_KEYS.list(query),
    queryFn: async () => errorUtils.unwrap(await interviewsService.listStaffInterviews(query)),
    enabled: isEnabled && session?.stage === 'ready',
  });
};

export {
  useStaffInterviews,
};
